import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter as Router } from 'react-router-dom'
import './styles/index.css'
import App from './App.tsx'
import BgAudio from './assets/audio/bg.mp3'

const audio = new Audio(BgAudio);
audio.loop = true;

document.addEventListener('click', () => {
  audio.play().catch(() => {
    console.log('需要用户交互后才能播放');
  });
}, { once: true });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Router>
      <App />
    </Router>
  </StrictMode>,
)